import React from 'react';
import {
  openPopupWindow,
} from '../../../../../../../emitters/popup';
import Popup from '../../../../../../dumb/Popup/B';
import WidgetForm from './WidgetForm';
import {apiAppAdd} from "../../../../../../../api/merchant/app";

module.exports = ({onUpdate}) => {
  openPopupWindow((setPopupState, popup) => {
    return () => {
      return (
        <Popup>
          <WidgetForm
            title="Create App"
            submitBtnText="Save Changes"
            onSubmit={apiAppAdd}
            onUpdate={onUpdate}
            onClose={popup.close}
            finalMessage={['New App created!']}
          />
        </Popup>
      );
    };
  });
};
